import {
  GET_PROGRAMMING_CONTENTS,
  GET_PROGRAMMING_CONTENT_BY_URL,
  GET_PROGRAMMING_CONTENTS_MENU,
  PROGRAMMING_CONTENT_EXECUTE_CODE,
  GET_PROGRAMMING_CONTENT_SUBMISSION_RESULT,
} from "app/utils/constants/paths";
import jwtAuthAxios from "./auth/jwtAuth";

const programmingContentService = {};

programmingContentService.getProgrammingContentsMenu = async (language) => {
  const params = new URLSearchParams({
    language,
    status: "ACTIVE",
    page: 0,
    size: 100,
  });

  const { data } = await jwtAuthAxios.get(
    `${GET_PROGRAMMING_CONTENTS_MENU}?${params.toString()}`
  );
  return data;
};

programmingContentService.getProgrammingContents = async (
  page,
  size,
  language
) => {
  let url = `${GET_PROGRAMMING_CONTENTS}?page=${page}&size=${size}`;

  if (language && language.length > 0) {
    url += `&language.equals=${language}`;
  }
  const res = await jwtAuthAxios.get(url);
  return res;
};

programmingContentService.getContentByUrl = async (url) => {
  const { data } = await jwtAuthAxios.get(
    `${GET_PROGRAMMING_CONTENT_BY_URL}/${url}`
  );
  return data;
};

programmingContentService.addProgrammingContent = async (content) => {
  const { data } = await jwtAuthAxios.post(GET_PROGRAMMING_CONTENTS, content);
  return data;
};

programmingContentService.updateProgrammingContent = async (content) => {
  const { data } = await jwtAuthAxios.put(
    `${GET_PROGRAMMING_CONTENTS}`,
    content
  );
  return data;
};

programmingContentService.executeCode = async (code) => {
  const { data } = await jwtAuthAxios.post(
    PROGRAMMING_CONTENT_EXECUTE_CODE,
    code
  );
  return data;
};

programmingContentService.getSubmissionResultForProgrammingContent = async (
  submissionId
) => {
  const { data } = await jwtAuthAxios.get(
    `${GET_PROGRAMMING_CONTENT_SUBMISSION_RESULT}/${submissionId}`
  );
  return data;
};

export default programmingContentService;
